
import React from "react";
import { TableCell } from "@/components/ui/table";
import { 
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, 
  DropdownMenuSeparator, DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { MoreVertical, Eye, EyeOff, ArchiveIcon, ArchiveRestore, Trash2, Send } from "lucide-react";

interface NotificationActionsProps {
  notificationId: string;
  isRead: boolean;
  isArchived: boolean;
  onMarkAsRead: (e: React.MouseEvent) => void;
  onMarkAsUnread: (e: React.MouseEvent) => void;
  onView: (id: string) => void;
  onArchive: (e: React.MouseEvent, id: string) => void;
  onRestore: (e: React.MouseEvent, id: string) => void;
  onDelete: (e: React.MouseEvent, id: string) => void;
  onSendWebhook?: (e: React.MouseEvent, id: string) => void;
  inlineActions?: React.ReactNode;
}

const NotificationActions = ({
  notificationId,
  isRead,
  isArchived,
  onMarkAsRead,
  onMarkAsUnread,
  onView,
  onArchive,
  onRestore,
  onDelete,
  onSendWebhook,
  inlineActions,
}: NotificationActionsProps) => {
  return (
    <TableCell>
      <div className="flex items-center justify-end gap-1.5">
        {inlineActions}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            size="sm"
            className="h-7 w-7 p-0"
            onClick={(e) => e.stopPropagation()}
          >
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48">
          <DropdownMenuItem onClick={() => onView(notificationId)}>
            <Eye className="h-4 w-4 mr-2" />
            <span>Details</span>
          </DropdownMenuItem>
          
          {onSendWebhook && (
            <>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={(e) => onSendWebhook(e, notificationId)}>
                <Send className="h-4 w-4 mr-2" />
                <span>Stuur webhook</span>
              </DropdownMenuItem>
            </>
          )}
          
          <DropdownMenuSeparator />
          
          {isRead ? (
            <DropdownMenuItem onClick={onMarkAsUnread}>
              <EyeOff className="h-4 w-4 mr-2" />
              <span>Markeren als ongelezen</span>
            </DropdownMenuItem>
          ) : (
            <DropdownMenuItem onClick={onMarkAsRead}>
              <Eye className="h-4 w-4 mr-2" />
              <span>Markeren als gelezen</span>
            </DropdownMenuItem>
          )}
          
          <DropdownMenuSeparator />
          
          {isArchived ? (
            <DropdownMenuItem onClick={(e) => onRestore(e, notificationId)}>
              <ArchiveRestore className="h-4 w-4 mr-2" />
              <span>Herstellen</span>
            </DropdownMenuItem>
          ) : (
            <DropdownMenuItem onClick={(e) => onArchive(e, notificationId)}>
              <ArchiveIcon className="h-4 w-4 mr-2" />
              <span>Archiveren</span>
            </DropdownMenuItem>
          )}
          
          <DropdownMenuItem 
            className="text-red-600 focus:text-red-600" 
            onClick={(e) => onDelete(e, notificationId)}
          >
            <Trash2 className="h-4 w-4 mr-2" />
            <span>Verwijderen</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      </div>
    </TableCell>
  );
};

export default NotificationActions;
